














import { CommonMudule } from "@/store/modules/common";
import { UserModule } from "@/store/modules/user";
import { Component, Vue, Prop } from "vue-property-decorator";
import moment from 'moment-mini'

@Component({
  name: "",
})
export default class extends Vue {
  @Prop({ default: "" }) private coverUrl!: string;
  created() {}

  get userInfo(){
    return UserModule.userInfo
  }

  get coverInfo(){
    return {
      organization:  CommonMudule.imgSource.name,
      customerName: CommonMudule.customerName,
      name: this.userInfo.name,
      positionName: this.userInfo.positionName,
      date: moment().format('YYYY-MM-DD'),
      gender: CommonMudule.customerInfo.gender
    }
  }
}
